import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CarrierApiSettingsDto } from 'src/app/models/settings/CarrierApiSettingsDto';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-carrier-api-settings',
  templateUrl: './carrier-api-settings.component.html',
  styleUrl: './carrier-api-settings.component.css'})
export class CarrierApiSettingsComponent implements OnInit {

  carrierApiSettings: CarrierApiSettingsDto[] = [];

  /**
   *
   */
  constructor(private settingsService: SettingsService, private router: Router) {
    
    
  }

  ngOnInit(): void {
    
    this.settingsService.getCarrierApiSettings().subscribe((data: CarrierApiSettingsDto[]) => {
      debugger
      this.carrierApiSettings = data;
    });
  }

  getAttributeId(attributeId: string) {
    switch (attributeId) {
      default:
        return attributeId;
      
    }
  }

  onToggleChange(event: any, carrierApiSetting: CarrierApiSettingsDto) {
    debugger

    carrierApiSetting.value = event.target.checked ? '1' : '0';
    this.settingsService.updateCarrierApiSetting(carrierApiSetting).subscribe((data: CarrierApiSettingsDto) => {
      debugger
      //this.carrierApiSettings = data;
    }); 
  }

  goBack() {
    this.router.navigate(['/home']);
  }
}

